import React, { useCallback } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import MaskedView from '@react-native-masked-view/masked-view';
import Text from 'design-system/Text';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
import { AppView, ButtonGroup, StatusBar } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useSelfieMaskView } from '../hooks/useSelfieMaskView';
import useUploadPOI from '../hooks/useUploadPOI';
import { isWeb } from '../../../constants';
const ConfirmSelfieScreen = ({ route, navigation }) => {
    const { paddingHorizontal } = useAppFrameDimensions(isWeb);
    const styles = useStyles(styleSet);
    const { flow, files, selfieFile, documentType } = route.params;
    const { cy, ry, maskElement } = useSelfieMaskView();
    const [onUpload] = useUploadPOI(flow, documentType);
    const retake = useCallback(async () => {
        navigation.goBack();
    }, []);
    const handleContinue = useCallback(() => {
        onUpload(files, selfieFile);
    }, [files, onUpload, selfieFile]);
    return (<AppView>
      <StatusBar barStyle="dark-content" animated/>
      <Image style={StyleSheet.absoluteFill} source={{ uri: selfieFile.path }}/>
      <View style={styles.flex}>
        <MaskedView style={styles.maskedView} maskElement={maskElement}>
          <View style={styles.maskCover}/>
        </MaskedView>
      </View>
      <View style={[styles.textsContainer, { paddingHorizontal, paddingTop: cy + ry + rem(34) }]} pointerEvents="none">
        <Text Text-16 centered>
          Make sure that your entire face is visible.
        </Text>
      </View>
      <ButtonGroup type="floating">
        <Button brandReversed title="Retake selfie" onPress={retake}/>
        <Button brand preventDoubleTap title="Upload selfie" onPress={handleContinue}/>
      </ButtonGroup>
    </AppView>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
    },
    textsContainer: {
        position: 'absolute',
        left: 0,
        right: 0,
        padding: rem(16),
    },
    flex: {
        flex: 1,
    },
    maskedView: {
        position: 'absolute',
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
    },
    imgContainer: {
        flex: 1,
    },
    maskCover: {
        flex: 1,
        backgroundColor: colors.background.dark,
    },
    preview: {
        width: '100%',
        height: '100%',
        flex: undefined,
    },
}));
export default ConfirmSelfieScreen;
